import PatientRegistrationRoutes from "./patient";
const Patient = () =>
    import ( /* webpackChunkName: "PatientRegister" */ "../../components/registration/patient/Patient");
import DoctorRegistrationRoutes from "./doctor";
import AlliedRegistrationRoutes from "./allied";
const Doctor = () =>
    import ( /* webpackChunkName: "DoctorRegister" */ "../../components/registration/doctor/Doctor");
const Allied = () =>
    import ( /* webpackChunkName: "DoctorRegister" */ "@/components/registration/doctor/Allied");

export default [{
        path: "patient",
        name: "register.patient",
        redirect: {
            name: "register.patient.owner"
        },
        component: Patient,
        // beforeEnter(to, from, next) {
        //     const role = localStorage.getItem("currentRole");
        //     if (role == "patient") {
        //         next();
        //     } else {
        //         next("/");
        //     }
        // },
        children: PatientRegistrationRoutes
    },
    {
        path: "doctor",
        name: "register.doctor",
        redirect: {
            name: "register.doctor.owner"
        },
        component: Doctor,
        // beforeEnter(to, from, next) {
        //     const role = localStorage.getItem("currentRole");
        //     if (role == "doctor") {
        //         next();
        //     } else {
        //         next("/");
        //     }
        // },
        children: DoctorRegistrationRoutes
    },
    {
        path: "allied",
        name: "register.allied",
        redirect: {
            name: "register.allied.owner"
        },
        component: Allied,
        // beforeEnter(to, from, next) {
        //     const role = localStorage.getItem("currentRole");
        //     if (role == "allied") {
        //         next();
        //     } else {
        //         next("/");
        //     }
        // },
        children: AlliedRegistrationRoutes
    },
];